import { useTranslation } from 'react-i18next';
import { groupByFor } from '@platform/core/lib/viewSettings';
import { builderViewRows, defaultViewChoices } from './builderViewRows';
import type { IBuilderCardProps } from './IBuilderCardProps';
import { setBacklogGroupBy, setDefaultView, toggleView, viewsOf } from './patchViews';

/**
 * «Подання записів» конструктора (прототип v4 bViews): 15 подань з описами — увімкнені позначені; «Типове подання» (серед увімкнених) і
 * «Групування беклогу за» (поля вибору). Сторінки модуля (огляд, поради) й подання, яких тип не має, не перемикаються.
 */
export function ViewsCard({ rt, published, editor, strings }: IBuilderCardProps) {
  const { t } = useTranslation();
  const rows = builderViewRows(rt, published, editor.patch);
  const { def } = viewsOf(rt, editor.patch);
  const groupBy = editor.patch.views?.settings?.backlog?.groupBy ?? groupByFor(rt);
  const selects = rt.fields.filter((f) => f.type === 'select' && !f.hidden);
  const why = (r: (typeof rows)[number]) => (r.page ? t('rtBuilder.pageView') : !r.on && r.disabled ? t('rtBuilder.noView') : r.disabled ? t('rtBuilder.lastView') : undefined);
  return (
    <section className="rb-card" aria-label={t('rtBuilder.views')}>
      <div className="rb-card__title">{t('rtBuilder.views')}</div>
      <div className="rb-checks">
        {rows.map((r) => (
          <label key={r.key} className="rb-checkrow" title={why(r)}>
            <input type="checkbox" className="rb-check" checked={r.on} disabled={!editor.canEdit || r.disabled}
              onChange={() => editor.apply((p) => toggleView(p, rt, r.key, !r.on))} />
            <span className="rb-checkrow__label">{t(`rtBuilder.viewNames.${r.key}`)}</span>
            <span className="rb-checkrow__desc">{t(`rtBuilder.viewDesc.${r.key}`)}</span>
          </label>
        ))}
      </div>
      <div className="rb-pair">
        <label className="rb-field"><span className="rb-field__label">{t('rtBuilder.defaultView')}</span>
          <select className="rb-select" value={def} disabled={!editor.canEdit} onChange={(e) => editor.apply((p) => setDefaultView(p, e.target.value))}>
            {defaultViewChoices(rt, editor.patch).map((v) => <option key={v} value={v}>{t(`rtBuilder.viewNames.${v}`, { defaultValue: v })}</option>)}
          </select>
        </label>
        <label className="rb-field"><span className="rb-field__label">{t('rtBuilder.backlogBy')}</span>
          <select className="rb-select" value={groupBy} disabled={!editor.canEdit} onChange={(e) => editor.apply((p) => setBacklogGroupBy(p, e.target.value))}>
            {selects.map((f) => <option key={f.key} value={f.key}>{strings.field(rt.key, f.key, f.label)}</option>)}
          </select>
        </label>
      </div>
    </section>
  );
}
